export var DELETE_FILTER_LIST_ITEM = 'DELETE_FILTER_LIST_ITEM';
var isDeleteEnabled = function isDeleteEnabled(_ref) {
  var isDefaultFilterRow = _ref.isDefaultFilterRow,
    isDisabled = _ref.isDisabled,
    nonRemovable = _ref.nonRemovable;
  return !isDefaultFilterRow && !isDisabled && !nonRemovable;
};
var DELETE_ACTION = {
  id: DELETE_FILTER_LIST_ITEM,
  name: __('Delete'),
  icon: 'icon-trash',
  isEnabled: isDeleteEnabled
};
var ACTIONS = [DELETE_ACTION];
export default ACTIONS;